import { useContext } from 'react';
import { AlertContext } from '@/contexts';

export const useAlert = () => {
	const alertContext = useContext(AlertContext);
	return alertContext;
};
